import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireGuest } from "@/lib/auth/require-auth";

// Auth route group (pathless): no sidebar, redirect-if-already-authed.
// Each child route provides its own AuthShell (split-panel layout), so this
// layout simply renders the outlet without any wrapper styling.
export const Route = createFileRoute("/_auth")({
  beforeLoad: async () => {
    await requireGuest();
  },
  component: AuthLayout,
});

function AuthLayout() {
  return <Outlet />;
}
